import {
  Button,
  Grid,
  TextField,
  Typography
} from '@material-ui/core';
import moment from 'moment';
import api from 'services/api';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { AMODULO_SISAREPASSENGER } from 'consts';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, withRouter } from 'react-router-dom';

/* Pega a URL da imagem do respectivo módulo */
const getBackgroundImage = (rota) => {
  if (rota === '/financas') return 'url(/images/authfinancas.jpg)';
  if (rota === '/front') return 'url(/images/auth.jpg)';
  if (rota === '/gerencial') return 'url(/images/authgerencial.jpg)';
  if (rota === '/crm') return 'url(/images/authcrm.jpg)';
  if (rota === '/frotas') return 'url(/images/authfrotas.jpg)';
  if (rota === '/estoque') return 'url(/images/authestoque.jpg)';
  if (rota === '/appcli') return 'url(/images/authappcli.jpg)';

  return 'url(/images/authappcli.jpg)';
};

/* Schema de validação do formulário de login */
const schema = {
  localizador: {
    presence: {
      allowEmpty: false,
      message: 'é obrigatório!'
    },
    length: {
      maximum: 15,
      message: 'deve ter no máximo 15 caracteres!'
    }
  }
};

/* Estilos da tela de login do módulo AppCli */
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%'
  },
  grid: { height: '100%' },
  quoteContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  quote: {
    backgroundColor: theme.palette.neutral,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: 600
  },
  quoteText: {
    color: theme.palette.black,
    fontWeight: 300
  },
  name: {
    marginTop: theme.spacing(3),
    color: theme.palette.white
  },
  bio: { color: theme.palette.white },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  logoImage: { marginLeft: theme.spacing(4) },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: { marginTop: theme.spacing(3) },
  socialButtons: { marginTop: theme.spacing(3) },
  socialIcon: { marginRight: theme.spacing(1) },
  sugestion: { marginTop: theme.spacing(2) },
  textField: { marginTop: theme.spacing(2) },
  signInButton: { margin: theme.spacing(2, 0) }
}));

/* Tela de login do portal do módulo AppCli */
const LoginAppCli = (props) => {
  const { history } = props;
  const classes = useStyles();
  const { pathname, search } = useLocation();
  const bg = getBackgroundImage(pathname);
  const queryParams = new URLSearchParams(search);
  const localizadorFromUrl = queryParams.get('localizador');

  // evita chamar o validaLocalizador mais de 1x quando vier por querystring
  const autoLoginFiredRef = useRef(false);

  const [configuracoes, setConfiguracoes] = useState({
    codEmpresa: 0,
    formaPDV: 0,
    traboOutraMoeda: 0
  });

  const [message, setMessage] = useState({ message: '' });

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
    rotaModulo: history.location.pathname,
    descModulo: 'AppCli',
    modulo: AMODULO_SISAREPASSENGER
  });

  // remove o token / usuário
  useEffect(() => {
    sessionStorage.removeItem('codUser');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('lastLogin');
    sessionStorage.removeItem('codOS');
    sessionStorage.removeItem('localizador');
    sessionStorage.removeItem('nomePax');
    sessionStorage.setItem('modulo', String(AMODULO_SISAREPASSENGER));
  }, []);

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(prev => ({
      ...prev,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  // atualiza os valores e marca os campos do formulário de login como tocados
  const handleChange = (event) => {
    event.persist();

    setFormState(prev => ({
      ...prev,
      values: {
        ...prev.values,
        [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value
      },
      touched: {
        ...prev.touched,
        [event.target.name]: true
      }
    }));
  };

  // busca e aplica as configurações da empresa
  const loadConfiguracoes = () => {
    return new Promise((resolve) => {
      let codEmpresa = sessionStorage.getItem('codEmpresa');

      if (codEmpresa === null || codEmpresa === undefined) {
        codEmpresa = 1;
      }

      const aURL = '/configuracoes/' + codEmpresa;

      api.get(aURL).then((response) => {
        const data = Array.isArray(response.data) ? response.data[0] : response.data;

        if (data) {
          setConfiguracoes({
            codEmpresa: data.codempresa,
            formaPDV: data.formapdv,
            traboOutraMoeda: data.traboutramoeda,
            fantasia: data.fantasia
          });

          sessionStorage.setItem('codEmpresa', data.codempresa);
          sessionStorage.setItem('trabOutraMoeda', data.traboutramoeda);
          sessionStorage.setItem('formaPDV', data.formapdv);
          sessionStorage.setItem('fantasia', data.fantasia);
        }

        resolve(response);
      }).catch((error) => {
        console.log(error);

        resolve(null);
      });
    });
  };

  // valida o localizador informado e autentica o passageiro na API
  const validaLocalizador = async (localizadorParam) => {
    const aURL = '/loginappcli';

    let loc = localizadorParam;

    if (loc === null || loc === undefined || String(loc).trim() === '') {
      loc = formState.values.localizador;
    }

    if (!loc) {
      setMessage({ message: 'Informe o localizador!' });

      return;
    }

    let codemp = sessionStorage.getItem('codEmpresa');

    if (codemp === null || codemp === undefined) codemp = 1;

    const data = {
      localizador: loc,
      codEmpresa: codemp
    };

    api.post(aURL, data).then((response) => {
      let lastLogin = new Date();
      lastLogin = moment(lastLogin, 'DD/MM/YYYY', true).format('DD/MM/YYYY');

      const res = Array.isArray(response.data) ? response.data[0] : response.data;

      if (!res) {
        setMessage({ message: 'A resposta da API é inválida!' });

        return;
      }

      sessionStorage.setItem('codOS', res.codos);
      sessionStorage.setItem('localizador', res.localizador);
      sessionStorage.setItem('nomePax', res.nomepax);
      sessionStorage.setItem('lastLogin', lastLogin);

      history.push('/appcli/programacao');

      setMessage({ message: 'ok' });
    }).catch((error) => {
      if (error.message === 'Network Error') {
        setMessage({ message: 'O serviço da API não respondeu!' });
      } else {
        setMessage({ message: 'O localizador é inválido!' });
        history.push('/appcli');
      }
    });
  };

  useEffect(() => {
    if (localizadorFromUrl && !autoLoginFiredRef.current) {
      autoLoginFiredRef.current = true;
      validaLocalizador(localizadorFromUrl);
    }
  }, [localizadorFromUrl]);

  // trata o submit do formulário de login
  const handleSignIn = async (event) => {
    event.preventDefault();

    if (sessionStorage.getItem('codEmpresa') === null) {
      sessionStorage.setItem('codEmpresa', 1);
    }

    await loadConfiguracoes();
    await validaLocalizador();
  };

  // verifica se um campo do formulário foi tocado e possui erro
  const hasError = (field) => !!(formState.touched[field] && formState.errors[field]);

  return (
    <div className={classes.root}>
      <Grid
        className={classes.grid}
        container
      >
        <Grid
          className={classes.quoteContainer}
          item
          lg={5}
        >
          <div
            className={classes.quote}
            style={{ backgroundImage: bg }}
          >
            <div className={classes.quoteInner}>
              <Typography
                className={classes.quoteText}
                variant="h1"
              />
            </div>
          </div>
        </Grid>

        <Grid
          className={classes.content}
          item
          lg={7}
          xs={12}
        >
          <div className={classes.content}>
            <div className={classes.contentBody}>
              <form
                className={classes.form}
                onSubmit={handleSignIn}
              >
                <Typography
                  className={classes.title}
                  variant="h2"
                >
                  Acesso
                </Typography>

                <Typography
                  color="textSecondary"
                  gutterBottom
                >
                  {'Programação'}
                </Typography>

                <TextField
                  className={classes.textField}
                  error={hasError('localizador')}
                  fullWidth
                  helperText={hasError('localizador') ? formState.errors.localizador[0] : null}
                  label="localizador"
                  name="localizador"
                  onChange={handleChange}
                  type="password"
                  value={formState.values.localizador || ''}
                  variant="outlined"
                />

                <Button
                  className={classes.signInButton}
                  color="primary"
                  disabled={!formState.isValid}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Entrar
                </Button>

                <Typography id="servicoAPI">
                  {message.message}
                </Typography>
              </form>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

LoginAppCli.propTypes = {
  history: PropTypes.object
};

export default withRouter(LoginAppCli);